import * as React from 'react';
import { BaseProps, GroupContainerType } from '../common/props';
import { DefaultGroupContainer } from './DefaultGroupContainer';
import { Classes } from '../index';
import { TagHeaderGroupContainer } from './TagHeaderGroupContainer';
import classNames from 'classnames';
import { NoHeaderGroupContainer } from './NoHeaderGroupContainer';
import { ContainerProps } from '../types';

export type GroupContainerProps = Omit<BaseProps, 'title'> & {
  title?: React.ReactNode | string;
  /**
   * Pokud je true, nezalamuje se dlouhý text do více řádků a aplikují se tři tečky, sndardně se text zalamuje.
   */
  noWrap?: boolean;
  inverse?: boolean;
  extra?: React.ReactNode;
  type?: GroupContainerType;
  headerContent?: React.ReactNode;
  banner?: React.ReactNode;
  /**
   * Propsy pro checkbox
   */
  checkable?: boolean;
  checked?: boolean;
  onCheck?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  /**
   * Pokud je true, vypne se padding u GroupContainer, má smysl pouze v případě, že se jedná default variantu
   */
  noPadding?: boolean;
  disabled?: boolean;
} & ContainerProps;
export const GroupContainer: React.FC<GroupContainerProps> = ({
  title,
  className,
  style,
  noWrap,
  extra,
  type = 'default',
  headerContent,
  children,
  banner,
  noPadding,
  noScroll,
  fullHeight,
  maxFullHeight,
  inverse,
  checkable,
  checked,
  onCheck,
  disabled,
}) => {
  const returnGardGroup = () => {
    switch (type) {
      case 'default':
        return (
          <DefaultGroupContainer
            noPadding={noPadding}
            className={className}
            style={style}
            children={children}
            title={title}
            noWrap={noWrap}
            extra={extra}
            headerContent={headerContent}
            banner={banner}
            inverse={inverse}
            checkable={checkable}
            checked={checked}
            onCheck={onCheck}
            disabled={disabled}
          />
        );
      case 'tagHeader':
        return (
          <TagHeaderGroupContainer
            className={className}
            style={style}
            children={children}
            title={title}
            banner={banner}
          />
        );
      case 'noHeader':
        return (
          <NoHeaderGroupContainer
            className={className}
            style={style}
            children={children}
          />
        );

      default:
        return <></>;
    }
  };
  return (
    <div
      className={classNames(Classes.GROUP_CONTAINER, className, {
        [Classes.CONTAINER_FULL_HEIGHT]: fullHeight,
        [Classes.NO_SCROLL]: noScroll,
        [Classes.CONTAINER_MAX_HEIGHT]: maxFullHeight,
      })}
      style={style}
    >
      {returnGardGroup()}
    </div>
  );
};
